<form [formGroup]="accountForm" (ngSubmit)="onSubmit()">
  <h3 class="title" i18n="@@office-settings.company-account-management">
    Account Management
  </h3>
  <div class="Profile-container">
    <div class="text-wrapper">Profile</div>
    <hr width="100%" size="2" />

    <kt-profile-image
      (change)="onProfilePictureChanged($event)"
      [logoPath]="logoPath"
      [disableUpload]="false"
      [companyName]="currentCompany?.companyName"
      type="company-logo"
    ></kt-profile-image>
    <span class="company-title" i18n="@@global.company-name"
      >Company Name
      <img
        src="/assets/media/icons/wallet/toolTip.svg"
        class="icon-default"
        alt=""
        matTooltip="Please contact our support if you wish to change this field"
        matTooltipPosition="above"
    /></span>
    <span class="company-text">{{ currentCompany?.companyName }}</span>
  </div>
  <div class="card-body">
    <div class="submit-button">
      <button
        type="submit"
        [disabled]="isSubmitBtnDisable"
        [ngClass]="{
          'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light':
            loading,
        }"
        class="btn btn-brand btn-elevate btn-pill"
        i18n="@@global.save-changes"
      >
        Save Changes
      </button>
    </div>
  </div>
</form>
